import { useEffect } from 'react';
import { useParams, useSearchParams } from 'react-router';

import { FullPageLoaderOverlayWithWhiteBackground } from '@/components/Layout/FullPageLoader';

import { TENANT_PARAM } from '@/constants/countries';

import { Tenant } from '@/types/common';

import { useValidateRemediation } from './hooks/useValidateRemediation';

const Remediation = () => {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');
  const jwe = searchParams.get('jwe');
  const { [TENANT_PARAM]: tenantParam } = useParams();
  const {
    mutate: validateRemediationCustomer,
    isPending: isValidatingRemediation,
  } = useValidateRemediation();
  useEffect(() => {
    if (token) {
      validateRemediationCustomer({
        token,
        tenant: tenantParam as Tenant,
        jwe,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token]);

  if (isValidatingRemediation) {
    return <FullPageLoaderOverlayWithWhiteBackground />;
  }
  return <div></div>;
};

export default Remediation;
